var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import DeviceDetector from "device-detector-js";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
export var getBrowserInfo = function () {
    var deviceDetector = new DeviceDetector();
    return deviceDetector.parse(window.navigator.userAgent);
};
export var getFingerPrint = function () {
    return FingerprintJS.load().then(function (fp) {
        return fp.get().then(function (result) {
            return result;
        });
    });
};
export var fetchIp = function (location) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, ip, latitude, longitude, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!location)
                    return [2, { ip: "n/a", latitude: "n/a", longitude: "n/a" }];
                if (!(typeof location === "string")) return [3, 4];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4, fetch(location).then(function (res) { return res.json(); })];
            case 2:
                _a = _b.sent(), ip = _a.ip, latitude = _a.latitude, longitude = _a.longitude;
                return [2, { ip: ip, latitude: latitude, longitude: longitude }];
            case 3:
                error_1 = _b.sent();
                console.log("fetchIp:", error_1);
                throw new Error("failed to fetch ip");
            case 4: return [2, location];
        }
    });
}); };
export var prepareBrowserInformation = function (app, location) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, client, device, os, _b, visitorId, _c, ip, latitude, longitude, err_1;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                _a = getBrowserInfo(), client = _a.client, device = _a.device, os = _a.os;
                return [4, Promise.all([getFingerPrint(), fetchIp(location)])];
            case 1:
                _b = _d.sent(), visitorId = _b[0].visitorId, _c = _b[1], ip = _c.ip, latitude = _c.latitude, longitude = _c.longitude;
                return [2, {
                        al: app.language || "en",
                        an: app.name || "",
                        at: "browser",
                        av: app.version || "",
                        rn: "",
                        ro: (os === null || os === void 0 ? void 0 : os.name) || "",
                        rb: (device === null || device === void 0 ? void 0 : device.brand) || "",
                        rm: (device === null || device === void 0 ? void 0 : device.model) || "",
                        rt: (device === null || device === void 0 ? void 0 : device.type) || "",
                        aid: app.identifier || "",
                        bb: "",
                        bi: visitorId,
                        bn: (client === null || client === void 0 ? void 0 : client.name) || "",
                        bua: window.navigator.userAgent.substring(0, 80),
                        bv: (client === null || client === void 0 ? void 0 : client.version) || "",
                        ci: ip,
                        rov: (os === null || os === void 0 ? void 0 : os.version) || "",
                        cm: "",
                        l: latitude + "-" + longitude
                    }];
            case 2:
                err_1 = _d.sent();
                console.log("prepareBrowserInformation", err_1);
                throw new Error("failed to prepare browser information");
            case 3: return [2];
        }
    });
}); };
